import { useEffect, useState } from 'react';
import { api } from '../api-client';
import { tenantStore } from '../lib/tenant-store';

export default function Mappings() {
  const tenantId = tenantStore.get() ?? '';
  const [tableName, setTableName] = useState('customer_mapping');
  const [mappings, setMappings] = useState<Array<{ source_key: string; target_key: string }>>([]);
  const [sourceKey, setSourceKey] = useState('');
  const [targetKey, setTargetKey] = useState('');
  const [message, setMessage] = useState('');

  async function reload() {
    if (!tenantId) return;
    const r = await api.listMappings(tenantId, tableName);
    setMappings(r.mappings);
  }

  useEffect(() => {
    reload();
  }, [tenantId, tableName]);

  if (!tenantId) return <p>先にテナントを設定してください</p>;

  async function handleAdd() {
    if (!sourceKey || !targetKey) return;
    await api.upsertMapping({ tenantId, tableName, sourceKey, targetKey });
    setSourceKey('');
    setTargetKey('');
    setMessage('✓ マッピング追加');
    await reload();
  }

  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">マッピングテーブル</h2>
      <p className="text-sm text-slate-600 mb-4">
        Bcart側ID ↔ 外部システム側コード の変換テーブル
      </p>

      <div className="mb-4">
        <label className="text-sm font-medium mr-2">テーブル:</label>
        <select value={tableName} onChange={(e) => setTableName(e.target.value)} className="px-3 py-2 border rounded">
          <option value="customer_mapping">customer_mapping（顧客）</option>
          <option value="product_mapping">product_mapping（商品）</option>
        </select>
      </div>

      <div className="bg-white rounded shadow border p-4 mb-4 max-w-xl">
        <h3 className="font-semibold mb-2">新規追加</h3>
        <div className="flex gap-2">
          <input
            value={sourceKey}
            onChange={(e) => setSourceKey(e.target.value)}
            placeholder="Bcart側ID（例: M001）"
            className="flex-1 px-3 py-2 border rounded"
          />
          <input
            value={targetKey}
            onChange={(e) => setTargetKey(e.target.value)}
            placeholder="外部側コード"
            className="flex-1 px-3 py-2 border rounded"
          />
          <button onClick={handleAdd} className="px-4 py-2 bg-blue-600 text-white rounded">
            追加
          </button>
        </div>
        {message && <p className="text-sm mt-2">{message}</p>}
      </div>

      <div className="bg-white rounded shadow border">
        <table className="w-full text-sm">
          <thead className="bg-slate-100 text-left">
            <tr>
              <th className="px-3 py-2">Bcart側</th>
              <th className="px-3 py-2">外部側</th>
            </tr>
          </thead>
          <tbody>
            {mappings.map((m) => (
              <tr key={m.source_key} className="border-t">
                <td className="px-3 py-2 font-mono">{m.source_key}</td>
                <td className="px-3 py-2 font-mono">{m.target_key}</td>
              </tr>
            ))}
            {mappings.length === 0 && (
              <tr>
                <td className="px-3 py-4 text-slate-500 text-sm" colSpan={2}>
                  マッピングがありません
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
